<template>
  <div class="lightingEnergy" v-loading="$store.state.user.loadingState">
    <AnalysisHead @getActiveTime="getActiveTime" />
    <div class="analysis innerW ashComWrap">
      <div class="comTitle">
        <h4>用能分析</h4>
      </div>
      <div
        class="comContentBox"
        style="display: flex; justify-content: space-between"
      >
        <div class="overview secondAshComWrap">
          <div class="comTitle">
            <h4>总览</h4>
          </div>
          <div class="comContentBox">
            <div class="topBox">
              <AnalysisOverview :overviewData="overviewData" />
            </div>
            <div class="bottomBox">
              <PublicEcharts
                :id="'overviewCharts'"
                :chartsData="overviewChartData"
                :type="'scaleCharts'"
              />
            </div>
          </div>
        </div>
        <div class="electricityTol secondAshComWrap">
          <div class="comTitle">
            <h4>楼栋照明用电TOP5</h4>
          </div>
          <div class="comContentBox">
            <PublicEcharts
              :id="'overview'"
              :chartsData="ecTolChart"
              :type="'stackedBar'"
            />
          </div>
        </div>
        <div class="electricityDay secondAshComWrap">
          <div class="comTitle">
            <h4>楼栋照明日间用电TOP5</h4>
          </div>
          <div class="comContentBox">
            <PublicEcharts
              :id="'electricityDay'"
              :chartsData="ecDayChart"
              :type="'horizontalBar'"
            />
          </div>
        </div>
        <div class="electricityNight secondAshComWrap">
          <div class="comTitle">
            <h4>楼栋照明夜间用电TOP5</h4>
          </div>
          <div class="comContentBox">
            <PublicEcharts
              :id="'electricityNight'"
              :chartsData="ecNightChart"
              :type="'horizontalBar'"
            />
          </div>
        </div>
      </div>
    </div>
    <AnalysisTwoChart
      :leftCharts="hoursCharts"
      :rightCharts="electricityCharts"
      :leftTitle="'24小时用能分析'"
      :rightTitle="rightTitle"
    />
    <AnalysisTable
      :title="'用电详情表'"
      :tabHead="tabHead"
      :tableData="tableData"
      :excelTitle="excelTitle"
      :showDownload="judgeAuthority('zixitong:zhaoming:lightingEnergy:export')"
    />
  </div>
</template>

<script>
import { dateFtt, judgeAuthority, handleNumDecimal } from "@/assets/js/utils";
import AnalysisHead from "@/components/fenxizujian/AnalysisHead";
import AnalysisOverview from "@/components/fenxizujian/AnalysisOverview";
import AnalysisTwoChart from "@/components/fenxizujian/AnalysisTwoChart";
import AnalysisTable from "@/components/fenxizujian/AnalysisTable";
import PublicEcharts from "@/components/PublicEcharts";
import api from "@/api";
export default {
  components: {
    AnalysisOverview,
    AnalysisHead,
    AnalysisTwoChart,
    AnalysisTable,
    PublicEcharts,
  },
  data() {
    return {
      activeTime: {},
      rightTitle: "",
      overviewData: {
        title: "总能耗",
        num: null,
        unit: "kw·h",
        yoy: "",
        mom: "",
      },
      tableData: [],
      tabHead: [],

      timeTitle: "每月",
      hoursCharts: {
        unit: "kw·h",
        type: "bar",
        xData: [],
        dataArr: [],
      },
      electricityCharts: {
        unit: "kw·h",
        type: "bar",
        xData: [],
        dataArr: [],
      },
      ecDayChart: {
        name: "日间用电",
        unit: "kw·h",
        xData: [],
        yData: [],
      },
      ecNightChart: {
        name: "夜间用电",
        unit: "kw·h",
        xData: [],
        yData: [],
      },
      ecTolChart: {
        unit: "kw·h",
        yData: [],
        dataArr: [],
      },
      overviewChartData: { dataArr: [] },
      excelTitle: "",
      pubParams: {},
    };
  },
  methods: {
    judgeAuthority,
    getTableHeade() {
      this.tabHead = [
        { label: "时间", prop: "time" },
        {
          label: `总用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "totalEC",
        },
        {
          label: `日间用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "dayEC",
        },
        { label: "日间占比/%", prop: "dayPercent" },
        {
          label: `夜间用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "nightEC",
        },
        { label: "夜间占比/%", prop: "nightPercent" },
        // {
        //   label: `公共区域照明用电/${
        //     this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
        //   }`,
        //   prop: "publicEC",
        // },
        // { label: "公共区域照明用电占比/%", prop: "publicPercent" },
        // {
        //   label: `建筑空间照明用电/${
        //     this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
        //   }`,
        //   prop: "buildEc",
        // },
        // { label: "建筑空间照明用电占比/%", prop: "buildPercent" },
      ];
    },
    getActiveTime(val) {
      this.$store.commit("SET_LOADING", true);
      this.activeTime = val;
      this.getTableHeade();
      this.excelTitle = `照明系统分析-${
        val.timeValue ? val.timeValue : "全部"
      }`;
      this.pubParams = {
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        assetType: "照明系统",
        type: this.activeTime.type,
        date: this.activeTime.timeValue,
      };
      this.getOverview();
      this.getFourEC();
      this.getECData();
      this.getTable();
      if (val.type == "MONTH") {
        this.rightTitle = "每日用电排名";
      } else if (val.type == "YEAR") {
        this.rightTitle = "每月用电排名";
      } else {
        this.rightTitle = "每年用电排名";
      }
      setTimeout(() => {
        this.$store.commit("SET_LOADING", false);
      }, 1000);
    },
    async getOverview() {
      this.overviewData.num = null;
      this.overviewData.yoy = "";
      this.overviewData.mom = "";
      this.overviewData.unit = "";

      this.overviewChartData.dataArr = [
        { name: "日间照明", value: null, unit: "kw·h" },
        { name: "夜间照明", value: null, unit: "kw·h" },
      ];
      this.ecTolChart.yData = [];
      this.ecTolChart.dataArr = [];

      this.ecDayChart.xData = [];
      this.ecDayChart.yData = [];
      this.ecNightChart.xData = [];
      this.ecNightChart.yData = [];

      let res = await api.LTGOSAnalysisOverview(this.pubParams);

      if (res && res.data.code == 200) {
        let data = res.data.data;
        this.overviewData.unit =
          data.overview.value > 10000 ? "万kw·h" : "kw·h";
        this.overviewData.num = handleNumDecimal(
          data.overview.value > 10000
            ? data.overview.value / 10000
            : data.overview.value
        );
        this.overviewData.yoy = data.overview.charts.find((v) => {
          return v.name == "同比";
        }).value;
        this.overviewData.mom = data.overview.charts.find((v) => {
          return v.name == "环比";
        }).value;
        this.overviewChartData.dataArr.map((v) => {
          v.value = data.overview.charts.find((item) => {
            return item.name == v.name;
          }).value;
        });

        let arr = [];
        data.generalCharts.slice(0, 5).map((v) => {
          this.ecTolChart.yData.push(v.name);
          arr.push(v.charts);
        });
        for (let i = 0; i < arr[0].length; i++) {
          this.ecTolChart.dataArr.push({ name: "", data: [] });
          arr.forEach((item) => {
            this.ecTolChart.dataArr[i].name =
              item[i].name == "day" ? "日间照明" : "夜间照明";
            this.ecTolChart.dataArr[i].data.push(item[i].value);
          });
        }
        data.dayCharts.slice(0, 5).map((v) => {
          this.ecDayChart.xData.push(v.value);
          this.ecDayChart.yData.push(v.name);
        });
        data.nightCharts.slice(0, 5).map((v) => {
          this.ecNightChart.xData.push(v.value);
          this.ecNightChart.yData.push(v.name);
        });
      }
    },

    async getFourEC() {
      this.hoursCharts.xData = [];
      this.hoursCharts.dataArr = [{ name: "用电量", data: [] }];
      this.$store
        .dispatch("publicGetFourEC", { params: this.pubParams })
        .then((res) => {
          this.hoursCharts.xData = res.xData;
          this.hoursCharts.dataArr[0].data = res.yArr;
        });
    },
    async getECData() {
      this.electricityCharts.xData = [];
      this.electricityCharts.dataArr = [];
      this.$store
        .dispatch("publicGetECData", { params: this.pubParams })
        .then((res) => {
          this.electricityCharts.xData = res.xData;
          this.electricityCharts.dataArr = res.dataArr;
        });
    },
    async getTable() {
      this.tableData = [];
      let res = await api.LTGOSAnalysisTable(this.pubParams);
      if (res && res.data.code == 200) {
        this.tableData = Array.from(res.data.data).map((item) => ({
          time:
            this.activeTime.type == "MONTH"
              ? dateFtt("dd日", new Date(item.ts))
              : this.activeTime.type == "YEAR"
              ? dateFtt("MM月", new Date(item.ts))
              : dateFtt("yyyy年", new Date(item.ts)),
          totalEC: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.totalEC
              : item.totalEC / 10000
          ),
          dayEC: handleNumDecimal(
            this.activeTime.type == "MONTH" ? item.dayEC : item.dayEC / 10000
          ),
          dayPercent: item.dayPercent,
          nightEC: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.nightEC
              : item.nightEC / 10000
          ),
          nightPercent: item.nightPercent,
          publicEC: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.publicEC
              : item.publicEC / 10000
          ),
          publicPercent: item.publicPercent,
          buildEc: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.buildEc
              : item.buildEc / 10000
          ),
          buildPercent: item.buildPercent,
        }));
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.lightingEnergy {
  width: 100%;
  overflow: auto;
  .innerW {
    width: $innerWidth;
    margin: 0 auto;
  }

  .analysis {
    height: 350px;
    .overview {
      width: 24%;
      height: 100%;
      .topBox {
        width: 85%;
        margin: 0 auto;
        height: 60%;
      }
      .bottomBox {
        width: 85%;
        margin: 0 auto;
        height: 40%;
      }
    }
    .electricityTol,
    .electricityDay,
    .electricityNight {
      width: 25%;
      height: 100%;
    }
  }
}
</style>
